/// <amd-module name="Feed/Legacy/Helpers/FeedPickerHelper" />
import { IHeaderItemPicker } from "VSSUI/Components/HubHeader/HubBreadcrumb.Props";

import * as PackageResources from "Feed/Common/Resources";
import * as Actions from "Feed/Legacy/Actions/Actions";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";


export class FeedPickerHelper {
    public static getFeedPicker(feeds: Feed[], selectedFeed: Feed): IHeaderItemPicker {
        const feedPicker: IHeaderItemPicker = {
            minItemsForSearchBox: 6,
            getItems: () => feeds,
            getListItem: (item: Feed) => ({ name: item.name, key: item.id }),
            isSearchable: true,
            selectedItem: selectedFeed,
            onSelectedItemChanged: this.onFeedPickerValueChange,
            searchTextPlaceholder: PackageResources.FeedPicker_Placeholder,
            searchNoResultsText: PackageResources.FilterList_NoResults
        };

        return feedPicker;
    }

    public static onFeedPickerValueChange = (feed: Feed): void => {
        Actions.FeedSelected.invoke(feed);
    };
}
